export var Customer;
(function (Customer) {
    /**
     * Reindex item data on BE
     */
    let Data;
    (function (Data) {
        Data.path = 'customer/data';
    })(Data = Customer.Data || (Customer.Data = {}));
    /**
     * Checks if customer exists
     */
    let Exists;
    (function (Exists) {
        Exists.path = 'customer/exists';
    })(Exists = Customer.Exists || (Customer.Exists = {}));
    /**
     * Logs custome in
     */
    let Login;
    (function (Login) {
        Login.path = 'customer/login';
    })(Login = Customer.Login || (Customer.Login = {}));
    /**
     * Logs custome out
     */
    let Logout;
    (function (Logout) {
        Logout.path = 'customer/logout';
    })(Logout = Customer.Logout || (Customer.Logout = {}));
    /**
     * Creates customer account
     */
    let Register;
    (function (Register) {
        Register.path = 'customer/register';
    })(Register = Customer.Register || (Customer.Register = {}));
    /**
     * Saves changes in customer data
     */
    let Save;
    (function (Save) {
        Save.path = 'customer/save';
    })(Save = Customer.Save || (Customer.Save = {}));
    /**
     * Save addresss in customer's address book
     */
    let SaveAddress;
    (function (SaveAddress) {
        SaveAddress.path = 'customer/saveAddress';
    })(SaveAddress = Customer.SaveAddress || (Customer.SaveAddress = {}));
    /**
     * Removes address from customer's address book
     */
    let RemoveAddress;
    (function (RemoveAddress) {
        RemoveAddress.path = 'customer/removeAddress';
    })(RemoveAddress = Customer.RemoveAddress || (Customer.RemoveAddress = {}));
    /**
     * Retrieves history orders
     */
    let Orders;
    (function (Orders) {
        Orders.path = 'customer/orders';
    })(Orders = Customer.Orders || (Customer.Orders = {}));
    /**
     * Removes credit card from customer account
     */
    let RemoveSavedCard;
    (function (RemoveSavedCard) {
        RemoveSavedCard.path = 'customer/removeSavedCard';
    })(RemoveSavedCard = Customer.RemoveSavedCard || (Customer.RemoveSavedCard = {}));
    /**
     * Reset password request (send link)
     */
    let RequestPasswordReset;
    (function (RequestPasswordReset) {
        RequestPasswordReset.path = 'customer/password';
    })(RequestPasswordReset = Customer.RequestPasswordReset || (Customer.RequestPasswordReset = {}));
    /**
     * Apply password reset (make change using link)
     */
    let ApplyPasswordReset;
    (function (ApplyPasswordReset) {
        ApplyPasswordReset.path = 'customer/resetPassword';
    })(ApplyPasswordReset = Customer.ApplyPasswordReset || (Customer.ApplyPasswordReset = {}));
})(Customer || (Customer = {}));
